import format from 'date-fns/format';
import { IDatetime } from '@/Framework/dateHelpers/Datetime';

interface IDateCellProps {
  cellData: IDatetime,
  cellName: string,
}

const getDateCell = ({ cellData }: IDateCellProps, formatType) => (
    cellData
        ? format(new Date(cellData.dateTime), formatType)
        : '-'
);

export default getDateCell;
